// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-media-overlay-caption{position:absolute;bottom:0;z-index:2;max-height:2.35em;padding:3px 7px;margin:0;overflow:hidden;font-size:10px;line-height:1.75;color:#fff;text-overflow:ellipsis;white-space:nowrap;background:rgba(0,0,0,.5)}@media (max-width:767px){.h-theme--risonare .v-media-overlay-caption{bottom:15px}}.v-media-overlay-caption--right{right:0;border-top-left-radius:2px}.v-media-overlay-caption--left{left:0;border-top-right-radius:2px}", ""]);
// Exports
module.exports = exports;
